import { CustomElements } from "@dulce/models/dist/slate.primatives"

export const isCustomElement = (element: unknown): element is CustomElements => {
  if (!element) return false
  if (typeof element !== "object") return false
  const hasType = "type" in element
  if (!hasType) return false
  return true
}